import { Client } from 'libs/e2api/Client';

/**
 * JWT token claims
 *
 * For more information on Token Claims:
 * @see https://venngage.atlassian.net/wiki/spaces/EN/pages/2054225936/E2+Infograph+Data+API#Authentication
 */
export enum Action {
  Read = 'r',
  Write = 'w',
  ReadAndWrite = 'rw',
}

export enum Scope {
  Infograph = 'i',
}

export type PermissionKey = `${Action}:${Scope}`;

export type Permission = {
  [key in PermissionKey]: string;
};

/**
 * Provider context
 */

export interface E2ClientContextI {
  client: Client | null;
  infographId: string | null;
  isReadonly: boolean; // TODO: Remove this when we have proper permission management in the E2 Backend
}

export type E2ClientProviderProps = {
  children: React.ReactNode;
};
